var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-09 09:33:53
 * @modify date 2021-09-09 09:33:53
 * @desc [分享]
 */
import jsCookie from 'js-cookie';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { delay, of } from 'rxjs';
import { EnumAPI } from '../../apis/index';
import AppEnv from '../../env';
import { AjaxBasics, Log } from '../../libraries';
import { onCreateFactoryAuth } from './auth';
import { onCreateFactoryUser } from './userModel';
let ShareController = class ShareController {
    constructor() {
        /**
         * 认证模块 默认从 cookie 中获取 token 不需要手动设置 token
         * 除非是地址栏解析或者其他方式等等
         * @memberof SystemController
         */
        this.Auth = onCreateFactoryAuth();
        /**
         * 用户信息
         * @memberof SystemController
         */
        this.User = onCreateFactoryUser();
        /**
         * 推广记录
         * @returns
         * shareCode ;         // 分享码  请求头         调用token接口返回字段中包含 shareCode
         * pageUrl;            //打开连接
         * shareTime;          //分享时间戳     格式：yyyy-MM-dd HH:mm:ss
         * shareType ;         //分享方式        1,"小程序三个点，或则卡片分享" ,2,"太阳码分享",3,"二维码分享"
         */
        this.recordLoading = false;
        /**
         * 生成推广码
         * @param shareUrl
         * @param shareModule
         * @returns
         */
        // getShareCode(shareUrl, shareModule) {
        //     return AjaxBasics.request<string>({ ...EnumAPI.content_share_code, body: { shareUrl, shareModule } })
        // }
    }
    /**
     * 兼容 之前的 value
     * @readonly
     * @memberof UserModel
     */
    get value() {
        return lodash.assign({}, this.Auth.Drainage, {});
    }
    /**
     * 兼容 之前的方法
     */
    merge(value = {}) {
        value = lodash.merge({}, this.value, value);
        this.Auth.onSaveDrainage(value);
    }
    /**
     * 兼容 之前的方法
     */
    set(value = {}) {
        this.Auth.onSaveDrainage(value);
    }
    get promoSource() {
        return lodash.get(this.Auth.Drainage, 'promoSource');
    }
    /**
     * 分享码 用户
     * @readonly
     * @memberof ShareController
     */
    get shareCode() {
        // this.User.shareCode
        return lodash.get(this.Auth.Drainage, 'shareCode');
    }
    get identityId() {
        // this.User.identityId
        return lodash.get(this.Auth.Drainage, 'identityId');
    }
    get userId() {
        // this.User.userId
        return lodash.get(this.Auth.Drainage, 'userId');
    }
    get businessType() {
        // shera BU
        // this.User.BU
        // SMB
        return lodash.get(this.Auth.Drainage, 'businessType');
    }
    /**
     * 分享时间戳
     * @readonly
     * @memberof ShareController
     */
    get shareTime() {
        return lodash.get(this.Auth.Drainage, 'shareTime', Date.now());
    }
    /**
     * 分享类型
     * @readonly 1 小程序&卡片，2 太阳码  3 二维码
     * @memberof ShareController
     */
    get shareType() {
        return lodash.get(this.Auth.Drainage, 'shareType', '1');
    }
    /**
     * 场景码
     * @readonly
     * @memberof ShareController
     */
    get scene() {
        return lodash.get(this.Auth.Drainage, 'scene');
    }
    /**
     * 获取请求头 参数值
     * @returns
     */
    getHeaderValue() {
        const code = lodash
            .map(lodash.pickBy(lodash.pick(this, lodash.keys(this.onCreateQuery())), lodash.identity), (value, key) => `${key}=${value}`)
            .join(';');
        return code;
    }
    /**
     * 创建分享参数
     */
    onCreateQuery(query = {}) {
        return lodash.assign({
            // 分享时间戳
            shareTime: Date.now(),
            // 用户分享码 或者 之前的分享码
            shareCode: this.User.shareCode || this.shareCode,
            // 身份id
            identityId: this.User.identityId || this.identityId,
            // 当前用户BU
            businessType: this.User.BU || this.businessType,
            // user id
            userId: this.User.userId || this.userId,
            // 类型
            shareType: this.shareType,
            // 场景值
            scene: this.scene,
            // 推广来源
            promoSource: this.promoSource,
        }, query);
    }
    /**
     * 写入cookie 主站分享信息同步
     */
    onWriteCookie() {
        const CookieValue = lodash.pickBy(this.value, (value, key) => {
            return value;
        });
        const str = lodash
            .map(CookieValue, (value, key) => `${key}=${value}`)
            .join(';');
        jsCookie.set('SHARE_INFO', str);
    }
    /**
     * 写入cookie 主站分享信息同步
     */
    onReadCookie() {
        const shareInfo = jsCookie.get('SHARE_INFO');
        if (shareInfo) {
            if (shareInfo.indexOf('{') != -1) {
                //上线bug 兼容一下 下次发版删掉
                TODO: jsCookie.remove('SHARE_INFO');
                return;
            }
            const shareArr = lodash.split(shareInfo, ';');
            const shareObj = {};
            shareArr.forEach((item) => {
                const [key, value] = item.split('=');
                if (value) {
                    shareObj[key] = value;
                }
            });
            this.merge(shareObj);
        }
    }
    /**
     * 解析分享参数
     * @memberof shareCode,shareTime,shareType
     */
    async onParseShare(query = {}) {
        await of(1).pipe(delay(400)).toPromise();
        await this.Auth.HydrateAsync;
        //不存在分享参数
        if (!lodash.get(query, 'shareCode') && !lodash.get(query, 'scene')) {
            console.log('【不存在分享参数】');
            if (lodash.isEmpty(this.value)) {
                // this.Auth有时候没数据
                this.onReadCookie();
            }
            return this;
        }
        query = this.onCompliantScene(query);
        const intentionNoBu = lodash.get(query, 'intentionNoBu');
        // query = this.getBusinessType(query); //后期改为后端处理 这是个异步
        query = lodash.pickBy(lodash.pick(query, lodash.keys(this.onCreateQuery())), lodash.identity);
        // 登陆以后不需要
        if (this.Auth.AccessToken) {
            lodash.unset(query, 'businessType');
        }
        else {
            // 意向伙伴 并且没有bu的
            if (intentionNoBu) {
                query = lodash.omit(query, ['businessType']);
                this.User.merge({ businessType: '' });
                lodash.set(query, 'intentionNoBu', intentionNoBu);
            }
        }
        Log.success('分享参数', query);
        this.set(query);
        this.mergeUserBU();
        this.getBusinessType(query); //后期改为后端处理 这是个异步
        this.onWriteCookie();
        return this;
    }
    mergeUserBU() {
        // 没登录
        if (!this.Auth.AccessToken && this.businessType) {
            this.User.merge({ businessType: this.businessType });
        }
    }
    /**
     * 获取分享人bu
     * @param query
     * @returns
     */
    async getBusinessType(query) {
        // try {
        //   if (!lodash.get(query, 'businessType') && lodash.get(query, 'userId')) {
        //     const businessType = await AjaxBasics.request({
        //       ...EnumAPI.bffsvr_get_sales_by_userid,
        //       body: { userId: lodash.get(query, 'userId') },
        //     });
        //     // lodash.set(query, 'businessType', res);
        //     this.merge({ businessType });
        //     // 没登录
        //     if (!this.User.BU && this.businessType) {
        //       this.User.merge({ businessType: this.businessType });
        //     }
        //   }
        // } catch (error) {
        //   console.error('LENG ~ error', error);
        // }
    }
    /**
     * 兼容小程序 scene
     * @param query
     * @returns
     */
    onCompliantScene(query) {
        // 扫码进入
        if (lodash.has(query, 'scene') && !lodash.has(query, 'shareCode')) {
            lodash.set(query, 'shareCode', lodash.get(query, 'scene'));
            lodash.set(query, 'shareType', '2');
        }
        else if (lodash.hasIn(query, 'share')) {
            const [token, shareCode, scene] = lodash.split(lodash.get(query, 'share'), AppEnv.shareSeparate);
            this.merge({ shareCode, scene });
        }
        return query;
    }
    async setRecord(query, pageUrl) {
        try {
            query = this.onCompliantScene(query);
            if (this.recordLoading ||
                lodash.isEmpty(lodash.get(query, 'shareCode'))) {
                return; //this.ShareSubject.complete()
            }
            this.recordLoading = true;
            const res = await AjaxBasics.request({
                ...EnumAPI.content_live_record,
                body: { pageUrl },
            });
            this.merge(res);
            this.recordLoading = false;
            return res;
        }
        catch (error) {
            this.recordLoading = false;
        }
    }
};
__decorate([
    computed
], ShareController.prototype, "value", null);
__decorate([
    computed
], ShareController.prototype, "shareCode", null);
__decorate([
    computed
], ShareController.prototype, "identityId", null);
__decorate([
    computed
], ShareController.prototype, "userId", null);
__decorate([
    computed
], ShareController.prototype, "businessType", null);
__decorate([
    computed
], ShareController.prototype, "shareTime", null);
__decorate([
    computed
], ShareController.prototype, "shareType", null);
__decorate([
    computed
], ShareController.prototype, "scene", null);
ShareController = __decorate([
    BindAll()
], ShareController);
export { ShareController };
